// Use only on the search page.

// Search::indexAction saves the filters from the submitted GET query. A second
// save from here races that write and can replace the filters with a raw string.
if ((new RegExp('/app/search')).test(window.location.href)) {
    $(function () {
        $('.search-form').on('submit', function () {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'search', { 'search_term': 'user_search' });
            }
        });
    });
}
